export default __webpack_public_path__ + "static/media/top_photo_img@2x.c8ed0b39.jpg";